// extracted by mini-css-extract-plugin
module.exports = {"panel__section":"styles_panel__section__EzKcD","section":"styles_section__pM0xR","heading":"styles_heading__75mtu"};